import Search from 'components/commons/search'
import { Button } from 'avo-ui'
import icTrash from 'assets/images/ic-trash.svg'
import { ACTION_TYPE } from 'constants/constant'
import icAddSquare from 'assets/images/ic-add-square.svg'
import Table from 'components/commons/table'
import ModalDelete from 'components/commons/modal-delete'
import { TABLE_STORE } from 'configs/main-page/configTableMSBBStore'
import { FormStore } from 'components/main-page/msbb-store/FormStore'
import { FormBanner } from 'components/main-page/msbb-store/FormBanner'

export const MSBBStore = ({
    dataList,
    storeDetail,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    selectedIds,
    onSubmit,
    onDelete,
    onSelectItemHandler,
    onActionRow,
    onHideForm,
    onChangeForm,
    onSearchCity,
    cityOptions,
    bannerDetail,
    onSubmitBanner,
    errorForm,
    isLoading,
    isLoadingBanner,
    isDeleting,
    isCreating,
    isUpdating,
    isUpdatingBanner,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex space-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
                <div className={'flex space-x-3'}>
                    <Button title={'Setting Banner'} onClick={() => setShowModal({ banner: true })} />
                    <Button
                        type={'outline'}
                        icon={icAddSquare}
                        title={'Create Store'}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                    />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_STORE.name}
                columns={TABLE_STORE.column}
                data={dataList?.stores}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Store'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.banner && (
                <FormBanner
                    show={modal?.banner}
                    onHideForm={() => onHideForm('banner')}
                    dataBanner={bannerDetail}
                    isLoading={isUpdatingBanner}
                    isLoadingBanner={isLoadingBanner}
                    onChangeForm={(value) => onChangeForm(value, 'banner')}
                    errorForm={errorForm}
                    onSubmit={onSubmitBanner}
                />
            )}
            {modal?.form && (
                <FormStore
                    show={modal?.form}
                    onHideForm={() => onHideForm()}
                    dataStore={storeDetail}
                    options={cityOptions}
                    onSearchOptions={onSearchCity}
                    isLoading={isCreating || isUpdating}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
